const A = {
  AMAZING: 5,
  GREAT: 4,
  OK: 3,
  BAD: 2,
  TERRIBLE: 1
};
export {
  A as CONVERSATION_RATING_IDS
};
